module.exports = __webpack_public_path__ + "img/Q09b.351e8dfd.png";